export default "<p>content-pass-promotion-banner works!</p>\r\n";